exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fee-input[data-v-3c4dd7f6] {\n  max-width: 50px;\n}\n.fee-input[data-v-3c4dd7f6]::-webkit-inner-spin-button,\n.fee-input[data-v-3c4dd7f6]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n.description[data-v-3c4dd7f6] {\n  max-width: 100%;\n}", ""]);

// exports
